import { render, staticRenderFns } from "./mgr-detail.vue?vue&type=template&id=74dbd571&scoped=true"
import script from "./mgr-detail.vue?vue&type=script&lang=js"
export * from "./mgr-detail.vue?vue&type=script&lang=js"
import style0 from "./mgr-detail.vue?vue&type=style&index=0&id=74dbd571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dbd571",
  null
  
)

export default component.exports